import React from 'react';

import cs from 'classnames';
import {Location} from 'history';
import {colors} from 'js-libs/sweetcommons/styles';
import pickBy from 'lodash/pickBy';
import {browserHistory, InjectedRouter} from 'react-router';
import styled from 'styled-components';

import {gt} from 'app/utils/i18n';

export const StyledFilterbarDIV = styled.div`
  background-color: ${colors.lightGray};
  border-color: rgba(0, 0, 0, 0.05);
`;

export const applyFilter = (
  router: InjectedRouter | typeof browserHistory,
  location: Location<any>,
  filter: Record<string, unknown>
) => router.replace(getFilterLink(router, location, filter));

export const getFilterLink = (
  router: InjectedRouter | typeof browserHistory,
  location: Location<any>,
  filter: Record<string, unknown>
) => ({
  pathname: location.pathname,
  query: pickBy(
    {...location.query, page: '', folders_page: '', ...filter},
    (value) => value !== ''
  ),
});

type Props = {
  children: React.ReactNode;
  viewingAll: boolean;
  resetFilters: () => void;
  className?: string;
  borderless?: boolean;
};

export const DashboardFilterbar = ({
  resetFilters,
  viewingAll,
  children,
  className,
  borderless,
}: Props) => (
  <DashboardFilterbarStructure className={className} borderless={borderless}>
    {children}
    {!viewingAll ? (
      <div className="col-12 col-md-auto text-right d-flex ml-auto justify-content-end align-items-center">
        <button
          className="btn btn-link btn-sm text-dark mt-2 mt-md-0 ml-2"
          onClick={resetFilters}
        >
          <i className="fa fa-times" /> {gt('Reset filters')}
        </button>
      </div>
    ) : null}
  </DashboardFilterbarStructure>
);

export function DashboardFilterbarStructure({
  children,
  className,
  borderless,
}: {
  children: React.ReactNode;
  className?: string;
  borderless?: boolean;
}) {
  return (
    <StyledFilterbarDIV
      className={cs(className, {
        'my-2': !borderless,
        card: !borderless,
      })}
    >
      <div
        className={cs({
          'card-body p-2': !borderless,
        })}
      >
        <div className="row no-gutters align-items-center">{children}</div>
      </div>
    </StyledFilterbarDIV>
  );
}
